import { render, staticRenderFns } from "./DialogConfirmTransfer.vue?vue&type=template&id=73e06016"
import script from "./DialogConfirmTransfer.vue?vue&type=script&lang=js"
export * from "./DialogConfirmTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports